export const homeObjOne = {
    id: "about",
    lightBg: false,
    lightText: false,
    lightTextDesc: true,
    topLine: "change someone's day",
    headline: "Messaging across all platforms",
    description:
        "Whether your cracking down on Linear algebra or Intro to Psychology, we got you covered on LSSHub. Get your questions reliably answered by students from all years. Search, chat, and study!",
    buttonLabel: "Click to enter",
    imgStart: false,
    img: require("../../images/svg-1.svg").default,
    alt: "devices",
    dark: true,
    primary: true,
    darkText: true,
};

export const homeObjTwo = {
    id: "stats",
    lightBg: true,
    lightText: true,
    lightTextDesc: true,
    topLine: "Your information is protected",
    headline: "Keeping you safe",
    description:
        "Access to the chat requires an email account and is authenticated precisely.",
    buttonLabel: "Start chatting",
    imgStart: true,
    img: require("../../images/svg-2.svg").default,
    alt: "statistics",
    dark: true,
    primary: true,
    darkText: false,
};

export const homeObjThree = {
    id: "contact",
    lightBg: false,
    lightText: false,
    lightTextDesc: true,
    topLine: "When in doubt, talk it out",
    headline: "Reply in 2 days",
    description:
        "We'll be happy to answer any inquiries or feedback: laurierstudentstudyhub@gmail.com",
    buttonLabel: "Enter the chat",
    imgStart: false,
    img: require("../../images/svg-3.svg").default,
    alt: "mail sent",
    dark: true,
    primary: true,
    darkText: true,
};
